<template>
  <v-dialog
    v-model="dialogSelectItem"
    max-width="720px">
    <template v-slot:activator="{ on }">
      <v-btn
          icon
          @click="initView"
          >
      <v-icon >find_in_page</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Selling Price Reference from Prev. Quote (if any)
      </v-card-title>
      <v-card-text>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="DataList"
          loading-text="Loading... Please wait"
          hide-actions
          dense
          item-key="id"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.refNo }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.materialNo }}</td>
              <td class="price-format">{{ toPriceFormat(props.item.sellingPrice) }}</td>
            </tr>
          </template>

        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import _ from 'lodash'

  export default {
    name: 'ViewPriceLineRef',
    mixins: [displayFormatterMixins],
    props: ['companyId', 'materialNo', 'quoId'],
    data: () => ({
      snack: false,
      snackColor: '',
      snackText: '',
      DataList: [],
      selected: [],
      totalRows: 0,
      rowsAmount: [5, 10, 20],
      dialogSelectItem: false,
      loading: true,
      searchBy: {
        quoRef: '',
        materialNo: ''
      },
      headers: [
        { text: 'Quo. Ref.', value: 'refNo' },
        { text: 'Quo. Name', value: 'name' },
        { text: 'Material No', value: 'materialNo' },
        { text: 'Selling Price', value: 'price.sellingPrice' }
      ],

      editedItem: {

      },
      suppPriceHint: '(IDR)',
      defaultItem: {

      }
    }),
    computed: {

    },

    watch: {

    },
    // called when page is created before dom
    created () {
      console.log('component created')
    },
    mounted () {
      console.log('component mounted')
    },
    methods: {
      initView () {
        console.log('init View')
        this.dialogSelectItem = true
        this.getItemQuotation()
      },
      async getItemQuotation () {
        try {
          // this.loading = true
          let response = await this.$http.get(`/api/quo/itemdetails?quoid=${this.quoId}&companyid=${this.companyId}&materialno=${this.materialNo}`)
          console.log('msk')
          console.log(response.data)
          // this.loading = false
          this.DataList = response.data
          console.debug('getItemQuotation XHR had been modified')
          // this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      closed () {
        this.selected = []
      },

    }
  }
</script>
